var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        id: "admin-non-metrc-browse-group-modal",
        title: _vm.isEdit ? "Edit Browse Group" : "Add Browse Group",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Strategy Key" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  disabled: "",
                  state: _vm.fieldValid("strategy_key"),
                },
                model: {
                  value: _vm.formData.strategy_key,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "strategy_key",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.strategy_key",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("strategy_key") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.strategy_key) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Group Key" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  disabled: _vm.isEdit,
                  state: _vm.fieldValid("group_key"),
                },
                model: {
                  value: _vm.formData.group_key,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "group_key",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.group_key",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("group_key") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.group_key) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Display Name" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("display_name") },
                model: {
                  value: _vm.formData.display_name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "display_name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.display_name",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("display_name") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.display_name) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Description" } },
            [
              _c("b-form-textarea", {
                attrs: { rows: "3", state: _vm.fieldValid("description") },
                model: {
                  value: _vm.formData.description,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "description",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.description",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("description") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.description) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Sort Order" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  state: _vm.fieldValid("sort_order"),
                },
                model: {
                  value: _vm.formData.sort_order,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sort_order", $$v)
                  },
                  expression: "formData.sort_order",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("sort_order") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.sort_order) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }